//helper function to build dynamic data-testids
const dataTestIdBuilder = (root, name, desc = '') =>
  `${root}-${name.toString().toLowerCase().replace(/\s+/g, '-')}${
    desc ? '-' : ''
  }${desc ? desc : ''}`;

export { dataTestIdBuilder };
